import type { ContentBlock } from '@beidou/agent-protocol';
import type { ChatMessage } from '../hooks/useChat';

interface ServerMessage {
  role: string;
  content: string | ContentBlock[];
  message_id?: string;
}

export function serverMessagesToChat(messages: ServerMessage[]): ChatMessage[] {
  return messages.map((m, i) => ({
    id: m.message_id || `hist-${i}`,
    role: m.role as 'user' | 'assistant',
    content: m.content,
    serverMessageId: m.role === 'assistant' ? m.message_id : undefined,
  }));
}

export type SessionHistoryResult =
  | { status: 'ok'; messages: ChatMessage[] }
  /** token 在服务端已失效，调用方应换 token 后重试 */
  | { status: 'unauthorized' }
  | { status: 'empty' };

export async function fetchSessionHistory(
  apiUrl: string,
  token: string
): Promise<SessionHistoryResult> {
  try {
    const resp = await fetch(`${apiUrl}/v1/session/me`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (resp.status === 401) return { status: 'unauthorized' };
    if (!resp.ok) return { status: 'empty' };
    const data = await resp.json();
    const raw = (data.messages || []) as ServerMessage[];
    if (raw.length === 0) return { status: 'empty' };
    return { status: 'ok', messages: serverMessagesToChat(raw) };
  } catch {
    return { status: 'empty' };
  }
}
